<div class="add-edit-location-dialog ups-dialog">
    <div class="dialog-header">
        <h2 mat-dialog-title>{{'AddShipFromLocation'|translate}}</h2>
        <mat-dialog-actions>
        </mat-dialog-actions>
        <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <ng-container [ngTemplateOutlet]="form"></ng-container>
    </mat-dialog-content>
</div>
<ng-template #form>
    <form [formGroup]="formGroup" class="ups-form">
        <div class="form-body">
            <mat-form-field>
                <mat-label>{{'LocationName'|translate}}</mat-label>
                <input matInput
                       required
                       type="text"
                       name="Location Name"
                       formControlName="nickName">
                <mat-error *ngIf="formGroup.controls.nickName?.errors">
                    <span *ngIf="formGroup.controls.nickName?.errors?.required">
                        {{'LocationNameRequired'|translate}}
                    </span>
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{'ShipperFirstName'|translate}}</mat-label>
                <input matInput
                       required
                       type="text"
                       name="Shipper FirstName"
                       formControlName="firstName">
                <mat-error *ngIf="formGroup.controls.firstName?.errors">
                    <span *ngIf="formGroup.controls.firstName?.errors?.required">
                        {{'FirstNameRequired'|translate}}
                    </span>
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{'ShipperLastName'|translate}}</mat-label>
                <input matInput
                       name="Shipper LastName"
                       required
                       type="text"
                       formControlName="lastName">
                <mat-error *ngIf="formGroup.controls.lastName?.errors">
                    <span *ngIf="formGroup.controls.lastName?.errors?.required">
                        {{'LastNameRequired'|translate}}
                    </span>
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{'CompanyName'|translate}}</mat-label>
                <input matInput
                       name="Company Name"
                       type="text"
                       formControlName="companyName">
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{'EmailAddress'|translate}}</mat-label>
                <input matInput
                       pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$"
                       name="email"
                       formControlName="email"
                       type="email">
                <mat-error *ngIf="formGroup.controls.email?.errors">
                    <span *ngIf="formGroup.controls.email?.errors">
                        {{'EmailAddressInvalidFormat'|translate}}
                    </span>
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{'Phone'|translate}}</mat-label>
                <input matInput
                       name="phone"
                       required
                       formControlName="telephoneNo"
                       minlength="10"
                       maxlength="15"
                       pattern="\d*"
                       type="text">
                <mat-error *ngIf="formGroup.controls.telephoneNo?.errors">
                    <span *ngIf="formGroup.controls.telephoneNo?.errors?.required">
                        {{'TelephoneNumberRequired'|translate}}
                    </span>
                    <span *ngIf="formGroup.controls.telephoneNo?.errors?.pattern">
                        {{'Only numeric digits are allowed.'|translate}}
                    </span>
                    <span *ngIf="!formGroup.controls.telephoneNo?.errors?.pattern && formGroup.controls.telephoneNo?.errors?.minlength">
                        {{'Phone number should be at least 10 digits.'|translate}}
                    </span>
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{'Fax'|translate}}</mat-label>
                <input matInput
                       name="fax"
                       formControlName="faxNo"
                       type="text">
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{'StreetAddress'|translate}}</mat-label>
                <input matInput
                       name="streetAddress"
                       required
                       formControlName="streetAddress"
                       type="text">
                <mat-error *ngIf="formGroup.controls.streetAddress?.errors">
                    <span *ngIf="formGroup.controls.streetAddress?.errors?.required">
                        {{'StreetAddressRequired'|translate}}
                    </span>
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{'SuiteOrApartment'|translate}}</mat-label>
                <input matInput
                       name="suite"
                       formControlName="apartmentSuite"
                       type="text">
            </mat-form-field>
            <mat-form-field *ngIf="isFRITUser">
                <mat-label>{{'AdditionalAddressInformation'|translate}}</mat-label>
                <input autocomplete="off" formControlName="additionalAddressInfo" matInput type="text">
                
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'Country' | translate }}</mat-label>
                <mat-select name="country"
                            (selectionChange)="onCountryChange($event.value)"
                            formControlName="country"
                            required>
                    <mat-option value="" disabled>{{ 'SelectCountry' | translate }}</mat-option>
                    <mat-option *ngFor="let country of countriesList" value="{{country.CountryCode}}">
                        {{country.CountryName}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="formGroup.controls.country?.errors">
                    <span *ngIf="formGroup.controls.country?.errors?.required">
                        {{'SelectACountry'|translate}}
                    </span>
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{'PostalCode'|translate}}</mat-label>
                <input matInput
                       name="postalCode"
                       [required]="isZipMandatory==true ? true : null"
                       (input)="getAddressbyZipCode($event.target)"
                       formControlName="zip"
                       type="text">
                <mat-error *ngIf="formGroup.controls.zip?.errors">
                    <span *ngIf="formGroup.controls.zip?.errors?.required">
                        {{'ZipCodeRequired'|translate}}
                    </span>
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{'City'|translate}}</mat-label>
                <input matInput
                       name="city"
                       required
                       formControlName="city"
                       maxlength="29"
                       type="text">
                <mat-error *ngIf="formGroup.controls.city?.errors">
                    <span *ngIf="formGroup.controls.city?.errors?.required">
                        {{'CityRequired'|translate}}
                    </span>
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{'StateOrProvince'|translate}}</mat-label>
                <input matInput
                       name="state"
                       required
                       formControlName="state"
                       type="text">
                <mat-error *ngIf="formGroup.controls.state?.errors">
                    <span *ngIf="formGroup.controls.state?.errors?.required">
                        {{'StateProvinceRequired'|translate}}
                    </span>
                </mat-error>
            </mat-form-field>
            <!--<div class="checkboxes">
                <mat-checkbox name="isdefault"
                              [(ngModel)]="shippingLocation.IsUserDefault">{{'SetAsDefault'|translate}}
                </mat-checkbox>
            </div>-->
        </div>
        <div class="form-footer">
            <div class="form-actions">
                <button mat-raised-button type="submit" [disabled]="!formGroup.valid" (click)="saveLocation()" class="form-action">
                    {{'Save'|translate}}
                </button>
            </div>
        </div>
    </form>
</ng-template>       
